<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Saldo Awal Hutang - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Saldo Awal Hutang - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Keuangan / Master / Saldo Awal / Hutang - Edit</span
        >
        <span v-else class="font-small"
          >/ Keuangan / Master / Saldo Awal / Hutang - Tambah</span
        >
      </div>
    </div>
    <form-hutang :id="id" />
  </div>
</template>

<script>
import FormHutang from '@/components/keuangan/saldo/FormHutang'

export default {
  components: {
    FormHutang,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
